import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { del, } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import { IChecklistItemSchema, IOperacaoAgricola } from "../../Interfaces/atividade/atividade";
import { IMaquina } from "../../Interfaces/equipamentos/equipamentos";
import { Modaladdchecklists } from "./add_checklist";

interface I_aux {
    list: IChecklistItemSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IChecklistItemSchema[]>>,
    obj_atividade: IOperacaoAgricola | undefined,
    list_aux: IMaquina[],
    set_obj_new_atividade: React.Dispatch<React.SetStateAction<IOperacaoAgricola | undefined>>,

}

export const Modalverlistachecklist: React.FC<I_aux> = ({
    list,
    list_aux,
    flag_open_modal,
    set_flag_open_modal,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    obj_atividade,
    set_obj_new_atividade,

}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();

    const [isLoading, setIsLoading] = useState<boolean>(false);


    const [flag_open_modal_ver_mais, set_flag_open_modal_ver_mais] = useState<boolean>(false);
    const [flag_open_modal_edit, set_flag_open_modal_edit] = useState<boolean>(false);
    const [flag_open_modal_add, set_flag_open_modal_add] = useState<boolean>(false);
    const [flag_open_modal_aux, set_flag_open_modal_aux] = useState<boolean>(false);
    const [obj_new, set_obj_new] = useState<IChecklistItemSchema>();

    const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });


    useEffect(() => {
        (async () => {
            set_list(obj_atividade?.checklist ?? [])
        })();
    }, []);

   

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes da Atividade

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                flag_open_modal_aux === true &&
                <Modaladdchecklists
                    list={list}
                    flag_open_modal={flag_open_modal_aux}
                    set_flag_open_modal={set_flag_open_modal_aux}
                    setMessage={setMessage}
                    setOpenSnackSuccess={setOpenSnackSuccess}
                    setOpenSnackError={setOpenSnackError}
                    set_list={set_list}
                    flag_open_modal_ver_mais={flag_open_modal_ver_mais}
                    set_flag_open_modal_ver_mais={set_flag_open_modal_ver_mais}
                    flag_open_modal_edit={flag_open_modal_edit}
                    set_flag_open_modal_edit={set_flag_open_modal_edit}
                    flag_open_modal_add={flag_open_modal_add}
                    set_flag_open_modal_add={set_flag_open_modal_add}
                    set_obj_new={set_obj_new}
                    obj_new={obj_new}
                    obj_atividade={obj_atividade}
                    lista_de_checklistes_aux={[]}
                    set_obj_new_atividade={set_obj_new_atividade}

                />
            }


            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col w-full flex-1 overflow-auto">
                            <div className="w-full p-5 flex justify-start">
                                <button
                                    type="button"
                                    onClick={() => {
                                        set_flag_open_modal_aux(true)
                                        set_flag_open_modal_edit(true)
                                        set_flag_open_modal_add(true)
                                        set_obj_new(undefined)
                                    }}
                                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                >
                                    <AddIcon sx={{ fontSize: 18 }} />
                                    Adicionar Registo de Checklists
                                </button>
                            </div>
                            <div className="flex flex-col w-full flex-1 overflow-auto px-5 pb-5">

                                {
                                    list.length > 0 ?
                                        <div className="w-full mt-4">
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Registos de Checklists</div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">



                                                {list.map((checklists, index) => {
                                                    const isSelected = obj_new?.id_check === checklists.id_check;
                                                    const isHovered = hover.flag && hover.id === checklists.id_check;
    
                                                    
                                                    return(
                                                    <div
                                                        key={index}
                                                        className={`
                                                            flex flex-col items-center justify-center w-[180px] min-w-[180px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                                            transition-all duration-200
                                                            ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                                            ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                                          `}
                                                            onMouseEnter={() => setHover({ flag: true, id: checklists.id_check })}
                                                            onMouseLeave={() => setHover({ flag: false, id: checklists.id_check })}
    
                                                            onClick={() => {
                                                                set_flag_open_modal_aux(true)
                                                                set_obj_new(checklists)
                                                                set_flag_open_modal_ver_mais(true)
                                                                set_flag_open_modal_edit(false)
                                                                set_flag_open_modal_add(false)
                                                            }}
                                                    >
                                                        <div className="space-y-2 text-sm w-full">
                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Item</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {checklists.item || '-'}
                                                                </span>
                                                            </div>
                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="text-gray-500">Ordem</span>
                                                                <span className="text-gray-800 font-medium truncate">
                                                                    {checklists.ordem || '-'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div
                                                                className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                            />
                                                       
                                                    </div>
                                                )})}
                                            </div>
                                        </div> : null
                                }

                            </div>




                        </div>
                    </>
            }

           
        </div>



    </Modal>)

}
